import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import Select from "react-select";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const SelectPriceGrn = ({
  sc, // Stock Code
  setVal, // Selected value
  handleOnChangeCategory, // Callback function for value change
  name, // Name of the select input
  scValue, // Pre-selected category value
  customPrice, // Additional pricing info (if any)
}) => {
  const [category, setCategory] = useState([]); // Holds fetched category data
  const [selectCategory, setSelectCategory] = useState(scValue); // Currently selected category
  const [options, setOptions] = useState([]); // Options for the dropdown
  const [defaultValue, setDefaultValue] = useState({}); // Default value for dropdown

  // Styles for the select input
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "30px",
      height: "30px",
      fontSize: "15px",
    }),
  };

  // Fetch category data based on the stock code
  const getCategory = async (sc) => {
    try {
      const result = sc
        ? await axios.get(`${BASE_URL}price/product/${sc}`)
        : { data: { priceTable: [] } }; // Fallback if sc is not provided

      const priceTable = result?.data?.priceTable || [];
      setCategory(priceTable);
    } catch (error) {
      console.error("Error fetching categories:", error.message);
      setCategory([]); // Fallback to empty array on error
    }
  };

  useEffect(() => {
    // Fetch category whenever sc changes
    getCategory(sc);
    setSelectCategory(scValue);
  }, [sc, scValue]);

  useEffect(() => {
    // Transform fetched category data into dropdown options
    if (category?.length > 0) {
      const priceList = category.map((price) => ({
        value: price?._id,
        label: `${price?.mrp}  [${price?.stock || 0}]`, // Fallback to 0 if stock is null/undefined
      }));
      setOptions(priceList);
      setDefaultValue(priceList[0] || { value: "0", label: "No Price" }); // Fallback for no options
    } else {
      setOptions([{ value: "0", label: "No Price" }]);
      setDefaultValue({ value: "0", label: "No Price" });
    }
  }, [category]);

  return (
    <Fragment>
      <Select
        styles={customStyles}
        className="basic-single"
        classNamePrefix="select"
        defaultValue={defaultValue}
        value={
          selectCategory
            ? options.find((opt) => opt.value === selectCategory) ||
              defaultValue
            : defaultValue
        }
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={true}
        onChange={(e) => handleOnChangeCategory(sc, e)}
        name={name}
        options={options}
      />
    </Fragment>
  );
};

export default SelectPriceGrn;
